module.exports = __webpack_public_path__ + "static/media/ch.18f8a9cd.jpeg";